<script lang="ts">
    export let option: any;
</script>

<template>
    {option.code} = {option.description}
</template>